// Normalizovaný klíč textu pro párování názvů (parametry, chipy): malá písmena,
// bez diakritiky, oddělovače jako „-" („Hmotnost:" = „hmotnost", „Příkon" =
// „prikon"). Jediný zdroj — dřív vedle sebe žily `slugOf` (specChips.js)
// a `specKey` (productDetail.js) s mírně jinými pravidly.
export function slugOf(text) {
  return String(text || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Symboly, které nesou význam názvu parametru („Ø kotouče" není „Kotouče",
// „Sklon °" není „Sklon %"). `slugOf` by je zahodil jako interpunkci, pro
// dedupe řádků parametrů se proto promítají do klíče tokenem. ²/³ a × mají
// písmennou podobu, kterou lidé píšou ručně („m2", „x"), tak se na ni mapují.
const SPEC_SYMBOLS = {
  'Ø': ' sym-prumer ',
  'ø': ' sym-prumer ',
  '⌀': ' sym-prumer ',
  '°': ' sym-stupen ',
  '%': ' sym-procento ',
  '‰': ' sym-promile ',
  '±': ' sym-plusminus ',
  '²': '2',
  '³': '3',
  '×': 'x',
};
const SPEC_SYMBOL_RE = /[Øø⌀°%‰±²³×]/g;

// Klíč názvu parametru pro dedupe (sjednocená karta parametrů): jako `slugOf`
// (diakritika, velikost písmen, dvojtečka a interpunkce se ignorují), ale
// významové symboly zůstávají tokenem. Název bez písmen a číslic vrací `null`
// = nikdy se s ničím neslučuje.
export function specKeyOf(text) {
  const key = slugOf(String(text || '').replace(SPEC_SYMBOL_RE, function (ch) {
    return SPEC_SYMBOLS[ch];
  }));
  return key || null;
}
